import { render, staticRenderFns } from "./OrderListShipping.vue?vue&type=template&id=1bb3a80a&scoped=true&"
import script from "./OrderListShipping.vue?vue&type=script&lang=js&"
export * from "./OrderListShipping.vue?vue&type=script&lang=js&"
import style0 from "./OrderListShipping.vue?vue&type=style&index=0&id=1bb3a80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb3a80a",
  null
  
)

export default component.exports